import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if(window){
    window.console.log=function(){};
  }
}


/**
 * since toFixed will not going to round 5
 * e.g 
 * 2.925 => 2.92 this is the result of the default number to fixed
 * when using this function the output will now be 2.925 => 2.93
 */
window['toFixed'] = function (number, decimals) {
	// var multiplier = Math.pow(10, decimals + 1),
	// wholeNumber = Math.floor(number * multiplier);
	// return Math.round(wholeNumber / 10) * 10 / multiplier;

	var num_sign = number >= 0 ? 1 : -1;
	return parseFloat((Math.round((number * Math.pow(10, decimals)) + (num_sign * 0.0001)) / Math.pow(10, decimals)).toFixed(decimals));


	// var x = Math.pow(10, Number(decimals) + 1);
	// return (Number(number) + (1 / x)).toFixed(decimals);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
